import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledPlaceholder = styled.div`
  width: 100%;
  height: 100%;

  border-radius: 4px;

  background: radial-gradient(95.43% 153.5% at 0% 0%, #98021c 0%, #1c1e21 100%);

  & img {
    border-radius: 4px;
  }
`

const Placeholder: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <StyledPlaceholder>{children}</StyledPlaceholder>

export default Placeholder
